/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseNavigationColumnFragment} from '@amblique/contentful/app/contentful/fragments/navigation-column/base-navigation-column.fragment';
import {LinkFragment} from '@amblique/contentful/app/contentful/fragments/link/link.fragment';

export const FullNavigationColumnFragment = gql`
  ${BaseNavigationColumnFragment}
  ${LinkFragment}

  fragment FullNavigationColumnFragment on NavigationColumn {
    ...BaseNavigationColumnFragment

    linksCollection {
      items {
        __typename
        ... on Link {
          ...LinkFragment
        }
      }
    }
    linksCursorCollection {
      items {
        __typename
        ... on Link {
          ...LinkFragment
        }
      }
    }
  }
`;
